var permissions = {
  CONCIERGE: {
    Add: 'CONCIERGE_INC',
    Edit: 'CONCIERGE_EDIT',
    Delete: 'CONCIERGE_DEL',
    Search: 'CONCIERGE_SRC',
    Manage: 'CONCIERGE_MANAGE'
  },
  MOVEMENT_TYPE: {
    Add: 'MOVEMENT_TYPE_INC',
    Edit: 'MOVEMENT_TYPE_EDIT',
    Delete: 'MOVEMENT_TYPE_DEL',
    Search: 'MOVEMENT_TYPE_SRC'
  },
  MVM: {
    Add: 'MVM_INC',
    Edit: 'MVM_EDIT',
    Search: 'MVM_SRC',
    Print: 'MVM_PRT',
    SuperUser: 'MVM_SUPER_USER',
    Invoice: 'MVM_INC_INVOICE',
    RegisterEntry: 'MVM_REGISTER_ENTRY',
    RegisterExit: 'MVM_REGISTER_EXIT',
    PendingAccount: 'MVM_PENDING_ACCOUNTING',
    PendingBilling: 'MVM_PENDING_BILLING',
    OutgoingRequest: 'MVM_INS_OUTGOING_REQUEST',
    PendingTransOrder: 'MVM_PENDING_TRASNP_ORDER',
    VehicleStayTime: 'MVM_VEHICLE_STAY_TIME',
    Monitor: 'MVM_MONITOR',
    MonitorExternalQueue: 'MVM_MONITOR_EXTERNAL_QUEUE',
    CriticalMaterialCall: 'MVM_CALL_MATERIAL_CRITICAL',
    DeleteInvoice: 'MVM_DEL_INVOICE',
    IncOutgoingMaterialInvoice: 'MVM_INC_OUT_MAT_INVOICE',
    EKanban: 'MVM_EKANBAN_SEARCH',
    LogDetail: 'MVM_SRC'
  },
  SHED: {
    Add: 'SHED_INC',
    Edit: 'SHED_EDIT',
    Delete: 'SHED_DEL',
    Search: 'SHED_SRC',
    UserManage: 'SHED_USER_MANAGE',
    Manage: 'SHED_MANAGE'
  },
  VEHICLE_TYPE: {
    Add: 'VEHICLE_TYPE_INC',
    Edit: 'VEHICLE_TYPE_EDIT',
    Delete: 'VEHICLE_TYPE_DEL',
    Search: 'VEHICLE_TYPE_SRC'
  },
  VEHICLE: {
    Add: 'VEHICLE_INC',
    Edit: 'VEHICLE_EDIT',
    Delete: 'VEHICLE_DEL',
    Search: 'VEHICLE_SRC'
  },
  FCM: {
    Add: 'PACKING_FCM_INC',
    Edit: 'PACKING_FCM_EDIT',
    Delete: 'PACKING_FCM_DEL',
    Search: 'PACKING_FCM_SRC'
  },
  SHIPPING_REQUEST: {
    Add: 'SHIPPING_REQUEST_INC',
    Edit: 'SHIPPING_REQUEST_EDIT',
    Delete: 'SHIPPING_REQUEST_DEL',
    Search: 'SHIPPING_REQUEST_SRC',
    Validate: 'SHIPPING_REQUEST_VAL',
    InvoiceValidate: 'SHIPPING_REQUEST_VAL_INV',
    View: 'SHIPPING_REQUEST_VIS',
    Monitor: 'SHIPPING_REQUEST_MONITOR',
    Supplier: 'SHIPPING_REQUEST_MAN_SUP'
  },
  DELIVERY_WINDOW: {
    Add: 'DELIVERY_WINDOW_INC',
    Edit: 'DELIVERY_WINDOW_EDIT',
    Delete: 'DELIVERY_WINDOW_DEL',
    Search: 'DELIVERY_WINDOW_SRC',
    Fiape: 'DELIVERY_WINDOW_FIAPE',
  },
  DEBIT: {
    Add: 'DEBIT_INC',
    Edit: 'DEBIT_EDIT',
    Delete: 'DEBIT_DEL',
    Search: 'DEBIT_SRC',
  },
  CONFERENCE: {
    Add: 'CONFERENCE_100_REG',
    Search: 'CONFERENCE_100_SRC',
  },
  ASN: {
    Add: 'ASN_INC',
    Edit: 'ASN_EDIT',
    Search: 'ASN_SRC',
    View: 'ASN_VIS',
    Crear: 'ASN_ARG_INC',
    ArgEdit: 'ASN_ARG_EDIT',
    ArgSearch: 'ASN_ARG_SRC',
    ArgView: 'ASN_ARG_VIS',
  },
  REPORTS: {
    BillingRecord: 'REPORT_BILLING_RECORD_VIS',
    BusinessSecurity: 'REPORT_BUSINESS_SECURITY_VIS',
    PendingAccounting: 'REPORT_PENDING_ACCOUNTING_VIS',
    PendingXMLRequest: 'REPORT_PENDING_XML_REQUEST_VIS',
    ScheduledBalance: 'REPORT_SCHEDULED_BALANCE_VIS',
    ShedMovement: 'REPORT_SHED_MOVEMENT_VIS',
    ShippingRequest: 'REPORT_SHIPPING_REQUEST_VIS',
    MvmGeneralData: 'REPORT_MVM_GENERAL_DATA',
    MvmList: 'REPORT_MVM_LIST'
  },
  MVC: {
    Add: 'MVC_INC',
    Edit: 'MVC_EDIT',
    Search: 'MVC_SRC',
    Receive: 'MVC_RECEIVE',
    Cancel: 'MVC_CANCEL'
  },
  XD: {
    CanBloqued: 'CAN_BLOQUED_XD'
  },
  MATERIAL_UNLOAD_SHED: {
    Add: 'APPLICATION_AE_API',
    Edit: 'APPLICATION_AE_API',
    Delete: 'APPLICATION_AE_API',
    Search: 'APPLICATION_AE_API'
  },
  DOCUMENTATION: {
    View: 'APPLICATION_AE_API'
  }
}

export default permissions;

